// eslint-disable-next-line import/no-amd
define([
    '../../../utils/Globals',
    'underscore',
    'backbone',
    '../models/ReportPropertyModel'
], (Globals, _, Backbone, ReportPropertyModel) => {
    const ReportPropertyCollection = Backbone.Collection.extend({
        url: Globals.baseUrl + 'reportProperties/reportProperty',
        initialize() {
        },
        comparator(item) {
            if (_.isUndefined(item.get('dialog_slide'))) {
                return item.get('dialog_seq');
            }
            return [parseInt(item.get('dialog_slide'), 10), parseInt(item.get('dialog_seq'), 10)];
        },
        model: ReportPropertyModel,
        getGrouped() {
            const slideG = this.groupBy(item => {
                if (_.isUndefined(item.get('dialog_slide'))) {
                    return 0;
                }
                return parseInt(item.get('dialog_slide'), 10);
            });
            _.each(slideG, (item, index) => {
                slideG[index] = _.groupBy(item, item2 => item2.get('dialog_seq'));
            });
            return slideG;
        },
        slides() {
            return _.size(this.getGrouped());
        },
        slideSize(slide) {
            const size = this.size(slide);
            console.log('size:' + size);
            return size;
        },
        size(slide) {
            const grouped = this.getGrouped();
            let size = 0;
            _.each(grouped, (slides, index) => {
                if (_.isUndefined(slide) || slide === index) {
                    size += _.size(slides);
                }
            });
            return size;
        },
        each(slide, func) {
            // console.log(this.first());
            const grouped = this.getGrouped();
            _.each(grouped, (slides, index) => {
                if (_.isUndefined(slide) || slide === parseInt(index, 10)) {
                    _.each(slides, (models, index2) => {
                        const model = _.first(models);
                        model.set('propertyArray', models);
                        if (_.isFunction(func)) {
                            func(model, index2);
                        }
                    });
                }
            });
        }
    });
    return ReportPropertyCollection;
});



// WEBPACK FOOTER //
// ./src/components/report/models/ReportPropertyCollection.js